/* eslint camelcase: 0 */

import { Litter } from './litter';
import { Seller } from './seller';

export type UserStatus = 'active' | 'inactive' | 'blocked';
export type SellerStatus = 'approved' | 'pending' | 'resubmit' | 'contacted';
export type UserTFAMethod = 'call' | 'email' | 'sms';
export type UserRoles = 'super' | 'admin' | 'manager' | 'editor' | 'seller' | 'user';

// Properties defined in UserResource.php
export type User = {
    id: number,
    first_name: string,
    last_name: string,
    fullName: string,
    email: string,
    status: UserStatus,
    phone: string,
    phone_extn: string,
    tfa_enabled: boolean,
    tfa_method: UserTFAMethod,
    email_verified_at?: string,
    created_at: string,
    updated_at: string,
    roles: UserRoles[],
    address_line_1?: string,
    address_line_2?: string | undefined,
    city?: string,
    state?: string,
    zip?: string,
    permissions: string[],
    draft_litter?: Litter,
    favorites?: object[], // Currently don't have/need a favorites type
    sellers?: Seller[],
    cart?: object, // Currently don't have/need a cart type
    ip?: string
};

export const isUser = (user: any): user is User => (
  'id' in user
    && 'first_name' in user
    && 'last_name' in user
    && 'email' in user
);
